import { Module } from "vuex";
import { actions, REFERENCE_DATA_ACTIONS } from "./actions";
import { mutations, REFERENCE_DATA_MUTATIONS } from "./mutations";
import { IReferenceDataState } from "./types";
import { IRootState } from "@/store/types";

export const state: IReferenceDataState = {
  isLoading: false,
  data: {},
  addNewDialogErrorMessage: undefined,
  banks: {},
  dataTable: {
    pagination: {
      descending: false
    }
  }
};

export namespace REFERENCE_DATA {
  export const ACTIONS = REFERENCE_DATA_ACTIONS;
  export const MUTATIONS = REFERENCE_DATA_MUTATIONS;
  export const NAME_SPACE = "referenceData";
  export const NS = (x: string): string => `${NAME_SPACE}/${x}`;
}

const namespaced: boolean = true;

export const referenceData: Module<IReferenceDataState, IRootState> = {
  namespaced,
  state,
  actions,
  mutations
};
